import Ad from './ad';
import './ad.less';

export default Ad;
